import { CustomerState } from "../interfaces/customer"
import { Types } from "../types"
import { CustomerActions } from "../types/customer/actionType"


const initialState: CustomerState = {
    insertCustomerPending: false,
    insertCustomerSuccess: false,
    insertCustomerError: '',
    successInsert: false,
    messageInsert: '',

    deleteCustomerPending: false,
    deleteCustomerSuccess: false,
    deleteCustomerError: '',

    updateCustomerPending: false,
    updateCustomerSuccess: false,
    updateCustomerError: '',
    successUpdate: false,
    messageUpdate: '',

    changeNotificationCustomerPending: false,
    changeNotificationCustomerSuccess: false,
    changeNotificationCustomerError: '',

    getLineIdByCustomerIdPending: false,
    getLineIdByCustomerIdSuccess: false,
    getLineIdByCustomerIdError: '',
    lineInfo: [],

    getQueueIdByCustomerIdPending: false,
    getQueueIdByCustomerIdSuccess: false,
    getQueueIdByCustomerIdError: '',
    queueInfo: []

}


const customerReducer = (state = initialState, action: CustomerActions) => {
    switch (action.type) {

        case Types.INSERT_CUSTOMER_REQUEST:
            return {
                ...state,
                insertCustomerPending: true,
                insertCustomerSuccess: false,
                insertCustomerError: '',
                successInsert: false,
                messageInsert: '',
            }

        case Types.INSERT_CUSTOMER_SUCCESS:
            return {
                ...state,
                insertCustomerPending: false,
                insertCustomerSuccess: true,
                insertCustomerError: '',
                successInsert: action.payload?.params?.success,
                messageInsert: action.payload?.params?.message,

            }


        case Types.INSERT_CUSTOMER_ERROR:
            return {
                ...state,
                insertCustomerPending: false,
                insertCustomerSuccess: false,
                insertCustomerError: action.payload,
                successInsert: false,
                messageInsert: '',
            }
        //Delete*********************************************************************************************************** */
        case Types.DELETE_CUSTOMER_REQUEST:
            return {
                ...state,
                deleteCustomerPending: true,
                deleteCustomerSuccess: false,
                deleteCustomerError: null,
            }

        case Types.DELETE_CUSTOMER_SUCCESS:
            return {
                ...state,
                deleteCustomerPending: false,
                deleteCustomerSuccess: true,
                deleteCustomerError: '',
            }

        case Types.DELETE_CUSTOMER_ERROR:
            return {
                ...state,
                deleteCustomerPending: false,
                deleteCustomerSuccess: false,
                deleteCustomerError: action.payload,
            }
        //update********************************************************************    
        case Types.UPDATE_CUSTOMER_REQUEST:
            return {
                ...state,
                updateCustomerPending: true,
                updateCustomerSuccess: false,
                updateCustomerError: '',
                successUpdate: false,
                messageUpdate: '',
            }

        case Types.UPDATE_CUSTOMER_SUCCESS:
            return {
                ...state,
                updateCustomerPending: false,
                updateCustomerSuccess: true,
                updateCustomerError: '',
                successUpdate: action.payload?.params?.success,
                messageUpdate: action.payload?.params?.message,
            }

        case Types.UPDATE_CUSTOMER_ERROR:
            return {
                ...state,
                updateCustomerPending: false,
                updateCustomerSuccess: false,
                updateCustomerError: action.payload,
                successUpdate: false,
                messageUpdate: '',
            }
        //change notification**********************************************************
        case Types.CHANGE_MEMBER_NOTIFICATION_REQUEST:
            return {
                ...state,
                changeNotificationCustomerPending: true,
                changeNotificationCustomerSuccess: false,
                changeNotificationCustomerError: '',
            }

        case Types.CHANGE_MEMBER_NOTIFICATION_SUCCESS:
            return {
                ...state,
                changeNotificationCustomerPending: false,
                changeNotificationCustomerSuccess: true,
                changeNotificationCustomerError: '',
            }

        case Types.CHANGE_MEMBER_NOTIFICATION_ERROR:
            return {
                ...state,
                changeNotificationCustomerPending: false,
                changeNotificationCustomerSuccess: false,
                changeNotificationCustomerError: action.payload,
            }
        //get line id by customer id
        case Types.GET_LINE_ID_BY_CUSTOMER_ID_REQUEST:
            return {
                ...state,
                getLineIdByCustomerIdPending: true,
                getLineIdByCustomerIdSuccess: false,
                getLineIdByCustomerIdError: '',
                lineInfo: []
            }

        case Types.GET_LINE_ID_BY_CUSTOMER_ID_SUCCESS:
            return {
                ...state,
                getLineIdByCustomerIdPending: false,
                getLineIdByCustomerIdSuccess: true,
                getLineIdByCustomerIdError: '',
                lineInfo: action.payload?.params
            }

        case Types.GET_LINE_ID_BY_CUSTOMER_ID_ERROR:
            return {
                ...state,
                getLineIdByCustomerIdPending: false,
                getLineIdByCustomerIdSuccess: false,
                getLineIdByCustomerIdError: action.payload,
                lineInfo: []
            }
        //************************************************************************************/
        case Types.RESET_CUSTOMER_LINE_ID_BY_CUSTOMER_ID_REQUEST:
            return {
                ...state,
                getLineIdByCustomerIdPending: false,
                getLineIdByCustomerIdSuccess: false,
                getLineIdByCustomerIdError: '',
                lineInfo: []
            }

        case Types.RESET_CUSTOMER_INSERT_UPDATE:
            return {
                ...state,
                updateCustomerPending: false,
                updateCustomerSuccess: false,
                updateCustomerError: '',
                successUpdate: false,
                messageUpdate: '',

                insertCustomerPending: false,
                insertCustomerSuccess: false,
                insertCustomerError: '',
                successInsert: false,
                messageInsert: '',

            }
        case Types.RESET_CUSTOMER_DELETE:
            return {
                ...state,
                deleteCustomerPending: false,
                deleteCustomerSuccess: false,
                deleteCustomerError: '',
                getLineIdByCustomerIdPending: false,
                getLineIdByCustomerIdSuccess: false,
                getLineIdByCustomerIdError: '',
                lineInfo: []

            }
        //*********************************************************************************************** */
        case Types.GET_QUEUE_BY_CUSTOMER_ID_REQUEST:
            return {
                ...state,
                getQueueIdByCustomerIdPending: true,
                getQueueIdByCustomerIdSuccess: false,
                getQueueIdByCustomerIdError: '',
                queueInfo: []
            }

        case Types.GET_QUEUE_BY_CUSTOMER_ID_SUCCESS:
            return {
                ...state,
                getQueueIdByCustomerIdPending: false,
                getQueueIdByCustomerIdSuccess: true,
                getQueueIdByCustomerIdError: '',
                queueInfo: action.payload?.params

            }
        case Types.GET_QUEUE_BY_CUSTOMER_ID_ERROR:
            return {
                ...state,
                getQueueIdByCustomerIdPending: false,
                getQueueIdByCustomerIdSuccess: false,
                getQueueIdByCustomerIdError: action.payload,
                queueInfo: []

            }

        //*************************************************************************************************** */
        case Types.RESET_GET_QUEUE_BY_CUSTOMER_ID:
            return {
                ...state,
                getQueueIdByCustomerIdPending: false,
                getQueueIdByCustomerIdSuccess: false,
                getQueueIdByCustomerIdError: '',
                queueInfo: []
            }

        case Types.RESET_GET_LINE_BY_CUSTOMER_ID:
            return {
                ...state,
                getLineIdByCustomerIdPending: false,
                getLineIdByCustomerIdSuccess: false,
                getLineIdByCustomerIdError: '',
                lineInfo: []
            }



        //***************************** */
        default:
            return {
                ...state,
            }
    }
}

export default customerReducer